import React from 'react'
import PropTypes from 'prop-types'

import S from './Checkbox.styled'

import * as Svg from '../Svg'
import { Text } from '../Text'

const Checkbox = ({
  children,
  className = '',
  value = '',
  groupName = '',
  label = '',
  isChecked = false,
  isDisabled = false,
  onClick = () => {},
  onChange = () => {},
  onBlur = () => {},
  accentColor,
  onKeyDown: customOnKeyDown = () => {},
}) => {
  const checkboxId = `checkbox-${Math.random().toString(36).slice(2, 11)}`

  const onKeyDown = (e) => {
    const { key, target } = e
    if (key === 'Enter') {
      e.preventDefault()
      target.click()
    }
    customOnKeyDown({ key, target })
  }

  const a11yProps = {
    id: checkboxId,
    'aria-checked': isChecked,
  }

  if (isDisabled) {
    a11yProps['aria-disabled'] = true
  }

  return (
    <S.Checkbox
      htmlFor={checkboxId}
      onMouseDown={(e) => e.preventDefault()}
      className={className}
      onBlur={onBlur}
      isDisabled={isDisabled}
      data-disabled={isDisabled}
      data-active={isChecked}
      accentColor={accentColor}
    >
      <div className="checkbox-wrapper">
        <S.Input
          {...a11yProps}
          type="checkbox"
          value={value}
          name={groupName}
          checked={isChecked}
          disabled={isDisabled}
          onClick={onClick}
          onChange={onChange}
          onKeyDown={onKeyDown}
          accentColor={accentColor}
        />
        <S.Checkmark
          className="checkmark"
          aria-hidden="true"
          accentColor={accentColor}
        >
          <Svg.Checkmark />
        </S.Checkmark>
      </div>
      <Text as="span" size="l">
        {children || label}
      </Text>
    </S.Checkbox>
  )
}

Checkbox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  value: PropTypes.string,
  groupName: PropTypes.string,
  label: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  accentColor: PropTypes.string,
  role: PropTypes.string,
}

export default Checkbox
